'use strict';

var React = require('react');
var Parser = require('commonmark').Parser;
var ReactRenderer = require('commonmark-react-renderer');
var propTypes = require('prop-types');

function ReactMarkdown(props) {
    React.Component.call(this, props);
}

ReactMarkdown.prototype = Object.create(React.Component.prototype);
ReactMarkdown.prototype.constructor = ReactMarkdown;

ReactMarkdown.prototype.render = function() {
    var containerProps = this.props.containerProps || {};
    var renderer = new ReactRenderer(this.props);
    var parser = new Parser(this.props.parserOptions);
    var ast = parser.parse(this.props.source || '');

    if (this.props.walker) {
        var walker = ast.walker();
        var event;

        while ((event = walker.next())) {
            this.props.walker.call(this, event, walker);
        }
    }

    if (this.props.className) {
        containerProps.className = this.props.className;
    }

    return React.createElement.apply(React,
        [this.props.containerTagName, containerProps, this.props.childBefore]
            .concat(renderer.render(ast).concat(
                [this.props.childAfter]
            ))
    );
};

ReactMarkdown.propTypes = {
    className: propTypes.string,
    containerProps: propTypes.object,
    source: propTypes.string.isRequired,
    containerTagName: propTypes.string,
    childBefore: propTypes.object,
    childAfter: propTypes.object,
    sourcePos: propTypes.bool,
    escapeHtml: propTypes.bool,
    skipHtml: propTypes.bool,
    softBreak: propTypes.string,
    allowNode: propTypes.func,
    allowedTypes: propTypes.array,
    disallowedTypes: propTypes.array,
    transformLinkUri: propTypes.func,
    transformImageUri: propTypes.func,
    unwrapDisallowed: propTypes.bool,
    renderers: propTypes.object,
    walker: propTypes.func,
    parserOptions: propTypes.object
};

ReactMarkdown.defaultProps = {
    containerTagName: 'div',
    parserOptions: {}
};

ReactMarkdown.types = ReactRenderer.types;
ReactMarkdown.renderers = ReactRenderer.renderers;
ReactMarkdown.uriTransformer = ReactRenderer.uriTransformer;

module.exports = ReactMarkdown;



//////////////////
// WEBPACK FOOTER
// ./~/react-markdown/src/react-markdown.js
// module id = 992
// module chunks = 0